import SessionHandler from '@sendbird/uikit-react/handlers/SessionHandler';
import { useCallback } from 'react';

import { setSendbirdAccessToken } from './chat.slice';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { useLazyTokensChatIssueRetrieveQuery } from 'src/common/external/bambi-api/bambiApi';
import { selectCurrentMembership } from 'src/features/auth/selectors';

export function useConfigureSession() {
  const dispatch = useAppDispatch();
  const currentMembership = useAppSelector(selectCurrentMembership);
  const [getChatToken] = useLazyTokensChatIssueRetrieveQuery();

  return useCallback(() => {
    const sessionHandler = new SessionHandler();
    sessionHandler.onSessionTokenRequired = (resolve, reject) => {
      // The catch is what keeps Sendbird from hanging: `error` here is only
      // the RTK-shaped failure, so a thrown rejection would leave
      // onSessionTokenRequired never settling either way.
      getChatToken({})
        .then(({ data, error }) => {
          if (error) {
            reject(error as Error);
          } else if (
            data &&
            // Extra check of currentMembership.id is string for ts
            typeof currentMembership?.id === 'string' &&
            !!currentMembership.id
          ) {
            dispatch(
              setSendbirdAccessToken({
                membershipId: currentMembership.id,
                sendbirdAccessToken: data.token,
              })
            );
            resolve(data.token);
          }
        })
        .catch((reason: unknown) => {
          reject(reason as Error);
        });
    };
    return sessionHandler;
  }, [dispatch, getChatToken, currentMembership?.id]);
}
